export type BodyFieldKey = 'weight' | 'height' | 'bicep' | 'waist' | 'chest' | 'hip';

export interface BodyFieldDef {
  key: BodyFieldKey;
  label: string;
  unit: string;
  /** Имя иконки lucide (kebab-case) — соответствует именам компонентов lucide-react. */
  icon: BodyFieldKey extends never ? never : string;
}

export type BodyTargets = Partial<Record<BodyFieldKey, number>>;

export interface BodyHistoryEntry {
  date: string;
  weight?: number;
  height?: number;
  bicep?: number;
  waist?: number;
  chest?: number;
  hip?: number;
}

export const BODY_FIELDS: ReadonlyArray<BodyFieldDef> = [
  { key: 'weight', label: 'Weight', unit: 'kg', icon: 'weight' },
  { key: 'height', label: 'Height', unit: 'cm', icon: 'ruler' },
  { key: 'bicep', label: 'Bicep', unit: 'cm', icon: 'biceps-flexed' },
  { key: 'waist', label: 'Waist', unit: 'cm', icon: 'minimize-2' },
  { key: 'chest', label: 'Chest', unit: 'cm', icon: 'shield' },
  { key: 'hip', label: 'Hip', unit: 'cm', icon: 'maximize-2' },
];

export const BODY_FIELD_BY_KEY: Record<BodyFieldKey, BodyFieldDef> = BODY_FIELDS.reduce(
  (acc, f) => {
    acc[f.key] = f;
    return acc;
  },
  {} as Record<BodyFieldKey, BodyFieldDef>,
);
